// extracted by mini-css-extract-plugin
export default {"root":"SkeepersCarouselReviews_root__37T8x","title":"SkeepersCarouselReviews_title__uHpoc"};